// extracted by mini-css-extract-plugin
export default {"container":"TextVariantPc_container__LQ7IX","labelContainer":"TextVariantPc_labelContainer__GwfFD","label":"TextVariantPc_label__BVka8","content":"TextVariantPc_content__MIKVv"};